<template>
  <div id="error-Page" :class="[errorPage ? 'hasBg' : '']">
    <div class="errorTextBox" v-if="!errorPage">
      {{errorMsg}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMsg: this.$route.query.errorMsg ? this.$route.query.errorMsg : '',
      errorPage: false
    }
  }
}
</script>
<style lang='less'>
#error-Page {
  position: relative;
  padding-top: 20px;
  font-size: 16px;
  height: 100%;
  &.hasBg{
    padding-top: 0px;
    background: #fff url(../../assets/images/errorPage/bg.jpg) no-repeat center center;
    background-size: cover;
  }
}
@media only screen and (max-width: 800px) {
  #error-Page {
    position: relative;
    padding-top: 20px;
    font-size: 24px;
    height: 100%;
    &.hasBg{
       padding-top: 0px;
       background: #fff url(../../assets/images/errorPage/bg.jpg) no-repeat center center;
      background-size: cover;
    }
  }
}
</style>
